class DetailsModal extends HTMLElement {
  constructor() {
    super();
    // Bind on the host. Querying details/summary here throws when those
    // nodes are not in the tree yet, and a throw in the constructor leaves
    // the search toggle with preventDefault and no open path.
    this.addEventListener('click', this.onHostClick.bind(this));
    this.addEventListener(
      'keyup',
      (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
  }

  connectedCallback() {
    this._bindTries = 0;
    this.bindModalNodes();
  }

  disconnectedCallback() {
    if (this._bindFrame != null) {
      cancelAnimationFrame(this._bindFrame);
      this._bindFrame = null;
    }
  }

  bindModalNodes() {
    if (!this.isConnected) return;
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    if (this.summaryToggle) {
      this.summaryToggle.setAttribute('role', 'button');
      return;
    }
    if (this._bindFrame) return;
    if ((this._bindTries || 0) >= 20) return;
    this._bindTries = (this._bindTries || 0) + 1;
    this._bindFrame = requestAnimationFrame(() => {
      this._bindFrame = null;
      this.bindModalNodes();
    });
  }

  isOpen() {
    const details = this.detailsContainer || this.querySelector('details');
    return !!(details && details.hasAttribute('open'));
  }

  pathHas(event, node) {
    if (!node) return false;
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    if (path.includes(node)) return true;
    return typeof node.contains === 'function' && node.contains(event.target);
  }

  onHostClick(event) {
    const closeButton = this.querySelector('button[type="button"]');
    if (this.pathHas(event, closeButton)) {
      this.close();
      return;
    }

    const summary = this.summaryToggle || this.querySelector('summary');
    if (this.pathHas(event, summary)) this.onSummaryClick(event);
  }

  onSummaryClick(event) {
    const details = this.detailsContainer || this.querySelector('details');
    if (!details) return;
    event.preventDefault();
    details.hasAttribute('open') ? this.close() : this.open();
  }

  onBodyClick(event) {
    const path = typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
    const onOverlay = path.some((node) => node && node.classList && node.classList.contains('modal-overlay'));
    if (!path.includes(this) || onOverlay) this.close(false);
  }

  open() {
    const details = this.detailsContainer || this.querySelector('details');
    if (!details) return;
    this.detailsContainer = details;
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    details.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const focusRoot = details.querySelector('[tabindex="-1"]');
    const focusInput = details.querySelector('input:not([type="hidden"])');
    if (focusRoot) trapFocus(focusRoot, focusInput || focusRoot);
  }

  close(focusToggle = true) {
    const details = this.detailsContainer || this.querySelector('details');
    const summary = this.summaryToggle || this.querySelector('summary');
    removeTrapFocus(focusToggle ? summary : null);
    if (details) details.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
